import apiClient from './client'
import type {
  GetProfileResponse,
  UpdateProfileRequest,
  UpdateProfileResponse,
  ChangePasswordRequest,
} from '@/types/api'

export const userApi = {
  getProfile() {
    return apiClient.get<GetProfileResponse>('/users/me')
  },

  updateProfile(data: UpdateProfileRequest) {
    return apiClient.patch<UpdateProfileResponse>('/users/me', data)
  },

  changePassword(data: ChangePasswordRequest) {
    return apiClient.patch('/users/me/password', data)
  },
}
